@if (report()) {
  <main id="main-content" class="main-content">
    <!-- <ng-container *ngTemplateOutlet="fundingExceeded"></ng-container> -->
    @for (region of getRequestedFundsRegions(); track region) {
      @if (regionExceedsValue(region, totalRequested[region])) {
        <ng-container *ngTemplateOutlet="fundingExceeded; context: {region: region}"></ng-container>
      }
    }
    @if (editable) {
      <div class="subtitle"><span class="red-normal">*</span>Indicates required field</div>
    }
    <h2 class="form-header">Regional Funding Recommendations</h2>
    @for (forest of report().forests; track forest) {
      @if (forest.form) {
        <mat-card [formGroup]="forest.form">
          <div class="title">{{forest.forest_name}}</div>
          @if (editable) {
            <div class="text-div">
              <b><span class="red">*</span>Regional Authorized Funds</b>
              <br>
                <span class="gray-text">
                  Please edit each treatment’s authorized funds by selecting the edit button. Remember, the total requested funds
                  <b>must not</b> exceed your region’s authorization level. (Regional authorization level amounts: Regions 1-6:
                  $500,000, Regions 8, 9, 10: $100,000.) For Treatment Map or KMZ package see <a target="_blank" rel="noopener noreferrer"
                  [href]="'/report-overview?report_id='+this.report().report_id+'&section=view-report&page=team-supporting'">Supporting
                Documents</a>.
              </span>
            </div>
          }
          @if (!editable) {
            <div class="text-subtitle">
              <b>RO Authorized Funding</b>
            </div>
          }
          <div class="table-container">
            <table mat-table [dataSource]="forest.data ?? []" class="mat-elevation-z8">
              <!-- Select Box Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="usa-checkbox">
                    <input class="usa-checkbox__input" id="{{forest.forest_id}}2" type="checkbox"
                      (change)="selectAll($event, forest.data)" aria-label="Toggle Select">
                      <label class="usa-checkbox__label usa-checkbox__label2 usa-checkbox__label3" for="{{forest.forest_id}}2">
                      </label>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                    [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                    @if (item.rowType == "normal-cell") {
                      <div class="usa-checkbox">
                        <input class="usa-checkbox__input" id="{{item.treatment_specification_id}}" type="checkbox"
                          [formControl]="item.select" (change)="selectCheck(item)" aria-label="Toggle Select">
                          <label class="usa-checkbox__label usa-checkbox__label2" for="{{item.treatment_specification_id}}">
                          </label>
                        </div>
                      }
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <!-- Treatment Column -->
                  <ng-container matColumnDef="treatment">
                    <th mat-header-cell *matHeaderCellDef>Treatment</th>
                    <td mat-cell *matCellDef="let item" class="treatment-cell"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''" [ngClass]="item.rowType">
                      {{item.treatment ?? "--"}}
                    </td>
                    <td mat-footer-cell *matFooterCellDef colspan="8"> Total Funds </td>
                  </ng-container>
                  <!-- Spec. # Column -->
                  <ng-container matColumnDef="spec_number">
                    <th mat-header-cell *matHeaderCellDef>Spec. #</th>
                    <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      @if (item.rowType == "normal-cell") {
                        {{item.spec_number}}
                      }
                    </td>
                  </ng-container>
                  <!-- Spec. Name Column -->
                  <ng-container matColumnDef="spec_name">
                    <th mat-header-cell *matHeaderCellDef>Spec. Name</th>
                    <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      @if (item.rowType == "normal-cell") {
                        {{item.spec_name ?? "--"}}
                      }
                    </td>
                  </ng-container>
                  <!-- Off-NFS Column -->
                  <ng-container matColumnDef="off_nfs">
                    <th mat-header-cell *matHeaderCellDef>Off-NFS</th>
                    <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      @if (item.rowType == "normal-cell") {
                        {{item.off_nfs ? "Yes": (item.off_nfs === null? "--":"No")}}
                      }
                    </td>
                  </ng-container>
                  <!-- Outside Fire Column -->
                  <ng-container matColumnDef="outside_fire">
                    <th mat-header-cell *matHeaderCellDef>Outside Fire</th>
                    <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      @if (item.rowType == "normal-cell") {
                        {{item.outside_fire ? "Yes": (item.outside_fire === null? "--":"No")}}
                      }
                    </td>
                  </ng-container>
                  <!-- Unit Type Column -->
                  <ng-container matColumnDef="unit_type">
                    <th mat-header-cell *matHeaderCellDef>Unit Type</th>
                    <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      @if (item.rowType == "normal-cell") {
                        {{item.unit_type ?? "--"}}
                      }
                    </td>
                  </ng-container>
                  <!-- num of units Column -->
                  <ng-container matColumnDef="unit_qty">
                    <th mat-header-cell *matHeaderCellDef style="text-align: end;"># of Units</th>
                    <td mat-cell *matCellDef="let item" style="text-align: end;" [ngClass]="item.rowType+' '+item.qty_class"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      @if (item.rowType != "bonus-top") {
                        @if (item.rowType == "normal-cell") {
                          {{item.unit_qty ?? "--"}}
                        } @else if (item.rowType == "bonus-data") {
                          {{item.approved_unit_qty ?? "--"}}
                        } @else {
                          {{item.wo_approved_unit_qty ?? "--"}}
                        }
                      }
                    </td>
                  </ng-container>
                  <!-- Unit Cost Column -->
                  <ng-container matColumnDef="unit_cost">
                    <th mat-header-cell *matHeaderCellDef style="text-align: end;">Unit Cost</th>
                    <td mat-cell *matCellDef="let item" style="text-align: end;" [ngClass]="item.rowType+' '+item.cost_class"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      @if (item.rowType != "bonus-top") {
                        @if (item.rowType == "normal-cell") {
                          {{item.unit_cost | currency | empty_check}}
                        } @else if (item.rowType == "bonus-data") {
                          {{item.approved_unit_cost | currency | empty_check}}
                        } @else {
                          {{item.wo_approved_unit_cost | currency | empty_check}}
                        }
                      }
                    </td>
                  </ng-container>
                  <!-- Cost Column -->
                  <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef style="text-align: end;">Requested Total ($)</th>
                    <td mat-cell *matCellDef="let item" style="text-align: end;" [ngClass]="item.rowType"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      @if (item.hideRequested != true && item.rowType != "bonus-top" && item.rowType == "normal-cell") {
                        {{unitTotal(item, true) | currency | empty_check}}
                      }
                    </td>
                    <td mat-footer-cell *matFooterCellDef style="text-align: end;"> {{forestTotal(forest.data) | currency |
                    empty_check}} </td>
                  </ng-container>
                  <!-- Authorized Total Column -->
                  <ng-container matColumnDef="authorized_total">
                    <th mat-header-cell *matHeaderCellDef style="text-align: end;">Authorized Total ($)</th>
                    <td mat-cell *matCellDef="let item" style="text-align: end;" class="green-cell" [ngClass]="item.rowType"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      @if (item.rowType != "bonus-top") {
                        @if (item.rowType == "normal-cell") {
                          {{(item.approved_unit_qty * item.approved_unit_cost) | currency | empty_check }}
                        } @else if (item.rowType == "bonus-data") {
                          {{(item.approved_unit_qty * item.approved_unit_cost) | currency | empty_check }}
                        } @else {
                          {{(item.wo_approved_unit_qty * item.wo_approved_unit_cost) | currency | empty_check }}
                        }
                      }
                    </td>
                    <td mat-footer-cell *matFooterCellDef style="text-align: end;" class="green-footer">
                    {{forestTotalAuthorized(forest.data) | currency}} </td>
                  </ng-container>
                  <!-- Authorized By Column -->
                  <ng-container matColumnDef="authorized_by">
                    <th mat-header-cell *matHeaderCellDef>Authorized By</th>
                    <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      {{ item.ro_authorized_by_id | authorizationMethod }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef colspan="3"></td>
                  </ng-container>
                  <!-- Authorized Status Column -->
                  <ng-container matColumnDef="authorized_status">
                    <th mat-header-cell *matHeaderCellDef>Authorization Status/Note</th>
                    <td mat-cell *matCellDef="let item" class="note-text" [matTooltip]="tooltip(item)" [ngClass]="item.rowType"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      <div class="note-div">
                        @for (id of item.authorization_status_ids; track id) {
                          <div>
                            {{getAuthStatusText(id)}}
                          </div>
                        }
                        <div>
                          @if (item.rowType == "normal-cell") {
                            {{ item.authorization_note }}
                          }
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <!-- Edit Column -->
                  <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef style="text-align: end;" class="right-sticky"></th>
                    <td mat-cell *matCellDef="let item" style="text-align: center" class="right-sticky" [ngClass]="item.rowType"
                      [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                      <div class="button-row-icon">
                        @if (user?.isROCO && item.rowType == 'normal-cell') {
                          <button mat-icon-button aria-label="edit" (click)="editFunding(item, 'RO')" style="font-size: 12px;"
                            matTooltip='Edit Authorized Treament Funds' matTooltipClass="tooltipClass2"
                            class="btn_edit right-sticky">
                            <fa-icon class="fa-sm" [icon]="faEdit" style="color: #216E1F;"></fa-icon></button>
                          }
                          @if (user?.isROCO && item.rowType == 'normal-cell') {
                            <button mat-icon-button aria-label="edit" (click)="fullyFunded(item)" style="font-size: 12px;"
                              matTooltip='Confirm RO Fully Funded' matTooltipClass="tooltipClass2" class="btn_edit right-sticky"
                              >
                              <fa-icon class="fa-sm" [icon]="faFileCircleCheck" style="color: #216E1F;"></fa-icon></button>
                            }
                          </div>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      <tr mat-footer-row *matFooterRowDef="footerDisplayedColumns" [hidden]="forest.data?.length == 0"></tr>
                      <!-- Row shown when there is no matching data. -->
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="14">
                          <div class="no-data">
                            <div class="no-data-icon">
                              <mat-icon class="no-data-icon1">search</mat-icon>
                              <mat-icon class="no-data-icon2">attach_money</mat-icon>
                            </div>
                            <div class="no-data-title">Requested Funds Unavailable</div>
                            <p style="max-width: 370px; text-align: center;">No treatment funds have been requested yet in the
                            Recommended Treatment Narratives section</p>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <!-- Treatments for WO -->
                  <div class="text-div big-space-above">
                    <b>Treatments Forwarded to WO</b><span class="gray-text"> (To be approved by WO only)</span>
                  </div>
                  <div class="table-container">
                    <table mat-table [dataSource]="forest.woData ?? []" class="mat-elevation-z8">
                      <!-- Select Box Column -->
                      <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                          <div class="usa-checkbox">
                            <input class="usa-checkbox__input" id="{{forest.forest_id}}" type="checkbox"
                              (change)="selectAll($event, forest.woData)" aria-label="Toggle Select">
                              <label class="usa-checkbox__label usa-checkbox__label2" for="{{forest.forest_id}}">
                              </label>
                            </div>
                          </th>
                          <td mat-cell *matCellDef="let item" [style.background-color]="item.isSelected ? '#FFF5E1' : 'white'"
                            [style.background-color]="item.select?.value ? '#FFF5E1' : ''" [ngClass]="item.rowType">
                            @if (item.rowType == "normal-cell") {
                              <div class="usa-checkbox">
                                <input class="usa-checkbox__input" id="{{item.treatment_specification_id}}2" type="checkbox"
                                  [formControl]="item.select" (change)="selectCheck(item)" aria-label="Toggle Select">
                                  <label class="usa-checkbox__label usa-checkbox__label2 usa-checkbox__label3"
                                    for="{{item.treatment_specification_id}}2">
                                  </label>
                                </div>
                              }
                            </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                          </ng-container>
                          <!-- Treatment Column -->
                          <ng-container matColumnDef="treatment">
                            <th mat-header-cell *matHeaderCellDef>Treatment</th>
                            <td mat-cell *matCellDef="let item" class="treatment-cell" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              {{item.treatment ?? "--"}}
                            </td>
                            <td mat-footer-cell *matFooterCellDef colspan="8"> Total Funds </td>
                          </ng-container>
                          <!-- Spec. # Column -->
                          <ng-container matColumnDef="spec_number">
                            <th mat-header-cell *matHeaderCellDef>Spec. #</th>
                            <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              @if (item.rowType == "normal-cell") {
                                {{item.spec_number}}
                              }
                            </td>
                          </ng-container>
                          <!-- Spec. Name Column -->
                          <ng-container matColumnDef="spec_name">
                            <th mat-header-cell *matHeaderCellDef>Spec. Name</th>
                            <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              @if (item.rowType == "normal-cell") {
                                {{item.spec_name ?? "--"}}
                              }
                            </td>
                          </ng-container>
                          <!-- Off-NFS Column -->
                          <ng-container matColumnDef="off_nfs">
                            <th mat-header-cell *matHeaderCellDef>Off-NFS</th>
                            <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              @if (item.rowType == "normal-cell") {
                                {{item.off_nfs ? "Yes": (item.off_nfs === null? "--":"No")}}
                              }
                            </td>
                          </ng-container>
                          <!-- Outside Fire Column -->
                          <ng-container matColumnDef="outside_fire">
                            <th mat-header-cell *matHeaderCellDef>Outside Fire</th>
                            <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              @if (item.rowType == "normal-cell") {
                                {{item.outside_fire ? "Yes": (item.outside_fire === null? "--":"No")}}
                              }
                            </td>
                          </ng-container>
                          <!-- Unit Type Column -->
                          <ng-container matColumnDef="unit_type">
                            <th mat-header-cell *matHeaderCellDef>Unit Type</th>
                            <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              @if (item.rowType == "normal-cell") {
                                {{item.unit_type ?? "--"}}
                              }
                            </td>
                          </ng-container>
                          <!-- num of units Column -->
                          <ng-container matColumnDef="unit_qty">
                            <th mat-header-cell *matHeaderCellDef style="text-align: end;"># of Units</th>
                            <td mat-cell *matCellDef="let item" style="text-align: end;" [ngClass]="item.rowType+' '+item.qty_class"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              @if (item.rowType != "bonus-top") {
                                @if (item.rowType == "normal-cell") {
                                  {{item.unit_qty ?? "--"}}
                                } @else if (item.rowType == "bonus-data") {
                                  {{item.approved_unit_qty ?? "--"}}
                                } @else {
                                  {{item.wo_approved_unit_qty ?? "--"}}
                                }
                              }
                            </td>
                          </ng-container>
                          <!-- Unit Cost Column -->
                          <ng-container matColumnDef="unit_cost">
                            <th mat-header-cell *matHeaderCellDef style="text-align: end;">Unit Cost</th>
                            <td mat-cell *matCellDef="let item" style="text-align: end;" [ngClass]="item.rowType+' '+item.cost_class"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              @if (item.rowType != "bonus-top") {
                                @if (item.rowType == "normal-cell") {
                                  {{item.unit_cost | currency | empty_check}}
                                } @else if (item.rowType == "bonus-data") {
                                  {{item.approved_unit_cost | currency | empty_check}}
                                } @else {
                                  {{item.wo_approved_unit_cost | currency | empty_check}}
                                }
                              }
                            </td>
                          </ng-container>
                          <!-- Cost Column -->
                          <ng-container matColumnDef="total">
                            <th mat-header-cell *matHeaderCellDef style="text-align: end;">Requested Total ($)</th>
                            <td mat-cell *matCellDef="let item" style="text-align: end;" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              @if (item.hideRequested != true && item.rowType != "bonus-top" && item.rowType == "normal-cell") {
                                {{unitTotal(item) | currency | empty_check}}
                              }
                            </td>
                            <td mat-footer-cell *matFooterCellDef style="text-align: end;"> {{forestTotal(forest.woData) | currency |
                            empty_check}} </td>
                          </ng-container>
                          <!-- Authorized Total Column -->
                          <ng-container matColumnDef="authorized_total">
                            <th mat-header-cell *matHeaderCellDef style="text-align: end;">Authorized Total ($)</th>
                            <td mat-cell *matCellDef="let item" style="text-align: end;" class="green-cell" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              @if (item.rowType != "bonus-top") {
                                @if (item.rowType == "normal-cell") {
                                  {{(item.wo_approved_unit_qty * item.wo_approved_unit_cost) | currency | empty_check }}
                                } @else if (item.rowType == "bonus-data") {
                                  {{(item.approved_unit_qty * item.approved_unit_cost) | currency | empty_check }}
                                } @else {
                                  {{(item.wo_approved_unit_qty * item.wo_approved_unit_cost) | currency | empty_check }}
                                }
                              }
                            </td>
                            <td mat-footer-cell *matFooterCellDef style="text-align: end;" class="green-footer">
                            {{forestWOTotalAuthorized(forest.woData) | currency}} </td>
                          </ng-container>
                          <!-- Authorized By Column -->
                          <ng-container matColumnDef="authorized_by">
                            <th mat-header-cell *matHeaderCellDef>Authorized By</th>
                            <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              {{ item.ro_authorized_by_id | authorizationMethod }}
                            </td>
                            <td mat-footer-cell *matFooterCellDef colspan="3"></td>
                          </ng-container>
                          <!-- Authorized Status Column -->
                          <ng-container matColumnDef="authorized_status">
                            <th mat-header-cell *matHeaderCellDef>Authorization Status/Note</th>
                            <td mat-cell *matCellDef="let item" class="note-text" [matTooltip]="tooltip(item)" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              <div class="note-div">
                                @for (id of item.authorization_status_ids; track id) {
                                  <div>
                                    {{getAuthStatusText(id)}}
                                  </div>
                                }
                                <div>
                                  @if (item.rowType == "normal-cell") {
                                    {{ item.authorization_note }}
                                  }
                                </div>
                              </div>
                            </td>
                          </ng-container>
                          <!-- Edit Column -->
                          <ng-container matColumnDef="edit">
                            <th mat-header-cell *matHeaderCellDef style="text-align: end;"></th>
                            <td mat-cell *matCellDef="let item" style="text-align: center;" [ngClass]="item.rowType"
                              [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
                              <div class="button-row-icon">
                                @if (user?.isROCO && item.rowType == 'normal-cell') {
                                  <button mat-icon-button aria-label="edit" (click)="editFunding(item, 'RO')" style="font-size: 12px;"
                                    matTooltip='Edit Authorized Treament Funds' matTooltipClass="tooltipClass2"
                                    class="btn_edit right-sticky">
                                    <fa-icon class="fa-sm" [icon]="faEdit" style="color: #216E1F;"></fa-icon></button>
                                  }
                                  @if (user?.isROCO && item.rowType == 'normal-cell') {
                                    <button mat-icon-button aria-label="edit" (click)="fullyFunded(item)" style="font-size: 12px;"
                                      matTooltip='Confirm RO Fully Funded' matTooltipClass="tooltipClass2" class="btn_edit right-sticky"
                                      >
                                      <fa-icon class="fa-sm" [icon]="faFileCircleCheck" style="color: #216E1F;"></fa-icon></button>
                                    }
                                  </div>
                                </td>
                              </ng-container>
                              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                              <tr mat-footer-row *matFooterRowDef="footerDisplayedColumns" [hidden]="forest.woData?.length == 0"></tr>
                              <!-- Row shown when there is no matching data. -->
                              <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="14">
                                  <div class="no-data">
                                    <div class="no-data-icon">
                                      <mat-icon class="no-data-icon1">search</mat-icon>
                                      <mat-icon class="no-data-icon2">attach_money</mat-icon>
                                    </div>
                                    <div class="no-data-title">No Treatments Available</div>
                                    <p style="max-width: 370px; text-align: center;">Treatment’s with authorization status of <b>Forward to
                                      WO</b> or <b>Split RO/WO authorization</b> will display here.</p>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </div>
                            <div class="text-div">
                              <b>P-Code</b>
                            </div>
                            <div class="text-div">
                              {{ report().job_code ?? "--" }}
                            </div>
                            <div class="text-div">
                              <b>Estimated Containment Date</b>
                            </div>
                            <div class="text-div">
                              {{( report().containment_date_est | date:"MM/dd/yyyy") || "--" }}
                            </div>
                            <div class="text-div">
                              <b>@if (editable) {
                                <span class="red">*</span>
                              }Job Code</b>
                            </div>
                            @if (editable) {
                              <mat-form-field appearance="outline" class="short-field">
                                <input matInput formControlName="job_code" required aria-label="Job Code">
                                <mat-error>Required Field</mat-error>
                              </mat-form-field>
                            }
                            @if (!editable) {
                              <div class="text-div">
                                {{ forest.form.value.job_code }}
                              </div>
                            }
                            <div class="text-div">
                              <b>@if (editable) {
                                <span class="red">*</span>
                              }Regional Authorization Narrative</b>
                            </div>
                            <!-- Rich Text input -->
                            @if (editable) {
                              <span class="gray-text tip-text"><b>Tip:</b> Use Ctrl+Shift+V to paste as plain text.</span>
                            }
                            @if (editable) {
                              <div class="NgxEditor__Wrapper">
                                <ngx-editor-menu [editor]="forest.editor" [toolbar]="toolbar"></ngx-editor-menu>
                                <ngx-editor formControlName="regional_authorization_narrative" [editor]="forest.editor"
                                placeholder="Enter Description"></ngx-editor>
                              </div>
                            }
                            @if (!editable) {
                              <div class="text" [innerHTML]="customATOB(forest.regional_authorization_narrative || '--')"></div>
                            }
                            @if (editable) {
                              <span class="gray-text text-count"
                                [ngClass]="{ 'text-count-red': forest.form.controls.regional_authorization_narrative.invalid }">
                                {{forest.form.controls.regional_authorization_narrative.value?.length ?? 0 | number:'1.0':'en-US'}} / 6,000
                                characters
                                used
                              </span>
                            }
                            @if (editable && forest.form.controls.regional_authorization_narrative.invalid) {
                              <div class="editor-error">
                                <fa-icon [icon]="faWarning" class="faWarning" aria-label="Warning"></fa-icon> Please shorten your text or
                                remove hidden formatting (e.g., paste as plain text using Ctrl+Shift+V).
                              </div>
                            }
                          </mat-card>
                        }
                      }
                      <!--pre assessment info-->
                      @if (pre_assessment_report) {
                        <app-ro-auth-funding [report]="pre_assessment_report" [gis_specialist]="gis_specialist"
                        [report_id]="report().report_id"></app-ro-auth-funding>
                      }
                    </main>
                  }

                  <ng-template #fundingExceeded let-region="region">
                    <div class="red-warning">

                      <fa-icon [icon]="faExclamationCircle" class="faWarning" aria-label="Error"></fa-icon>
                      <div class="support-text">
                        <b>The Authorized Total ($) amount in {{ getForestsInRegion(region) }} exceed Region {{region}} authorization
                          level
                        amount of {{regionMaxFunds(region) | currency : 'USD' : 'symbol' : '1.0-0'}}.</b>
                        <br>
                          Please review and modify each treatment on both forests until the <b>Authorized Total is under
                        {{regionMaxFunds(region) | currency : 'USD' : 'symbol' : '1.0-0'}}.</b>
                        <br>
                          If a treatment cannot be authorized at the regional level, select the “Forward to WO” option.
                        </div>
                      </div>
                    </ng-template>